import {sumArray} from '../../../utilities/arrays';

/**
 * calculate
 * @param {*} setResults 
 * @param {*} state 
 * @returns 
 */
 const calculate = (setResults, state) => {
    const { base, baseCount, mold, apiList } = state;
   
    const {factor,density} = base;
    
    
    let results = {};

  
    //Blank Vehicle (g)
    //dimensional analysis: 1 * mL * g/mL = g
    results.vehicleBlank = baseCount * mold * density

    //Silicon dioxide colloidal amount (g)
    //dimensional analysis: g/mL * mL * 1 = g
    const siO2Concentration = 1/100; //g/mL
    results.siO2 = siO2Concentration * mold * baseCount;

    //Amount of API (g)
    //dimensional analysis: mg * g/mg * 1 = g
    const mgTog = 1/1000; //g/mg
    results.apiList = apiList.map(item=> item.quantity* mgTog * baseCount);
    
    //Vehicle (g)
    //dimensional analysis: g - (sum(g)+g)*1 = g
    results.vehicle = results.vehicleBlank - 
      (  (  sumArray(results.apiList) + results.siO2  ) * factor  );  

    setResults(results);
    return results;
 };

 export default calculate;